import { Injectable, Type } from '@angular/core';
import { BaseDynamicWidgetComponent } from '../redux/components/base-dynamic-widget.component';

export const WIDGET_REGISTRY = new Map<string, Type<BaseDynamicWidgetComponent>>();

/**
 * Service that is shared across all the application, and registers all available widgets that can be instantiated.
 */

@Injectable({
  providedIn: 'root',
})
export class WidgetRegistryService {
  register(items: { name: string; widgetClass: Type<BaseDynamicWidgetComponent> }[]): void {
    items.forEach(({ name, widgetClass }) => {
      WIDGET_REGISTRY.set(name, widgetClass);
    });
  }

  get(widgetName: string): Type<BaseDynamicWidgetComponent> {
    if (!WIDGET_REGISTRY.has(widgetName)) {
      throw new Error(
        `The widget ${widgetName} is not registered in the global widget registry. To solve this, register it in its module constructor.`
      );
    }
    const widget = WIDGET_REGISTRY.get(widgetName);
    return widget;
  }
}
